import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEventContext } from '../../../context/event/hooks/use-event-context';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { Image } from '../../../subcomponents/image/image';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { defaultEventImageProps, eventImagePropsValidator } from './types/props';
import { getEventCdnUrlForMedia } from './utils/get-event-cdn-url-for-media';
import { getEventImagePlaceholderType } from './utils/get-event-image-placeholder-type';
import { getFormattedEventImageAltText } from './utils/get-formatted-event-image-alt-text';
const b = bemClassBuilder('v-event-image');
export const EventImage = observer(props => {
    const { i18n, accessibilityText, config: { enableSkeletonLoadingIndicators } } = useOccContext();
    const { config, cdnOptions } = props;
    const { event } = useEventContext();
    if (!event)
        return enableSkeletonLoadingIndicators ? _jsx(EventImageSkeleton, {}) : null;
    const { mediaType } = config;
    return (_jsx("div", Object.assign({ className: b.block({ mediaType }) }, { children: _jsx(Image, { className: b.element('img'), src: getEventCdnUrlForMedia(event, mediaType, cdnOptions.eventImage), placeholderType: getEventImagePlaceholderType(mediaType), alt: getFormattedEventImageAltText(event, mediaType, accessibilityText, i18n) }) })));
});
EventImage.displayName = 'EventImage';
export const EventImageSkeleton = () => _jsx("div", { className: b.block({ skeleton: true }) });
EventImageSkeleton.displayName = 'EventImageSkeleton';
/**
 * The **Event Image** component renders an image for an event.
 */
export const EventImageComponent = withComponentWrapper(EventImage, defaultEventImageProps, eventImagePropsValidator);
